<template>
    <Row :gutter="10" type="flex" class="grid-header header-fixed mx-0 pl-40">
        <Col :span="3">
            Indent ID
        </Col>
        <Col :span="3">
            Status
        </Col>
        <Col :span="4">
            Destination 
        </Col>
        <Col :span="3">
            Incoterms | FF
        </Col>
    </Row>
</template>
<script>
export default {
  data() {
    return {
      
    }
  }
}
</script>
